export enum IconFa {
  Fas = 'fas',
  Far = 'far',
  Fal = 'fal',
  Fab = 'fab',
}
